import Vue from "vue";
import Buefy from "buefy";
// import "buefy/dist/buefy.css";
import "@/style.scss";

Vue.use(Buefy);
